import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Flashcard } from '../models/flashcard.model';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  initSession(): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/chat-sessions/init`, {});
  }

  postMessage(chatId: number, message: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/chat-sessions/message`, { chatId, message });
  }

  initLearnChat(learnsetId: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/learn-session/ai-chat/init`, { learnsetId });
  }

  postLearnMessage(lessonId: number, message: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/learn-session/ai-chat/post`, { lessonId, message });
  }

  initCreateFlashcardSession(learnsetId: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/create-flashcards-session/init`, { learnsetId });
  }

  initSimpleChatSession(): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/chat/init`, {});
  }

  postSimpleChatMessage(sessionId: number, message: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/chat/post-message`, { sessionId, message });
  }

  postCreateFlashcardMessage(sessionId: number, message: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/create-flashcards-session/post`, { sessionId, message });
  }

  generateChatFlashcards(sessionId: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/create-flashcards-session/generate`, { sessionId });
  }

  saveChatFlashcards(sessionId: number, flashcards: Flashcard[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/create-flashcards-session/save-flashcards`, { sessionId, flashcards });
  }
}
